import { lazy } from "react";
import routes from "./routes";

export const publicRoutesData = [
  {
    path: routes.login,
    props: {},
    Comp: lazy(() => import("pages/login")),
  },
  {
    path: routes.forgotPassword,
    props: {},
    Comp: lazy(() => import("pages/forgotPassword")),
  },
  {
    path: routes.register,
    props: {},
    Comp: lazy(() => import("pages/register")),
  },
  {
    path: routes.ResetPassword,
    props: {},
    Comp: lazy(() => import("pages/confirmReset")),
  },
  {
    path: routes.ConfirmEmail,
    props: {},
    Comp: lazy(() => import("pages/confirmEmail")),
  },
];

export const cabinetRoutesData = [
  {
    path: routes.personalAccount,
    props: {},
    Comp: lazy(() => import("pages/personalAccount")),
  },
  {
    path: routes.myBalance,
    props: {},
    Comp: lazy(() => import("pages/myBalance")),
  },
  {
    path: routes.syncOrder,
    props: {},
    Comp: lazy(() => import("pages/syncOrder")),
  },
  {
    path: routes.MyVehicles,
    props: {},
    Comp: lazy(() => import("pages/myVehicles")),
  },
  {
    path: routes.MyFriends,
    props: {},
    Comp: lazy(() => import("pages/myFriends")),
  },
  {
    path: routes.MyPartners,
    props: {},
    Comp: lazy(() => import("pages/myPartners")),
  },
  {
    path: routes.profile,
    props: {},
    Comp: lazy(() => import("pages/profile")),
  },
  {
    path: routes.StationsMap,
    props: {},
    Comp: lazy(() => import("pages/stationsMap")),
  },
  {
    path: routes.Transactions,
    props: {},
    Comp: lazy(() => import("pages/transactions")),
  },
];
